<template>
  <div class="black_list">
    <top-title :name="name"></top-title>
    <div class="section-right-content-box">
      <div class="search_module">
        <!-- 筛选部分 -->
        <div class="screen-box" style="text-align: left;" :model="searchParams">
          <div class="item">
            <div class="input-box">
              <span class="input-title">ighuguy：</span>
              <!-- <el-date-picker
                v-model="timeRangePicker"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker> -->
              <div class="my_select_time">
                <el-date-picker
                    prefix-icon="no_icon"
                    v-model="startTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 120px;;font-size:12px"
                    class="time1"
                    :clearable="false">
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                    prefix-icon="no_icon"
                    v-model="endTime"
                    type="datetime"
                    :placeholder="'选择日期时间'"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 145px;;font-size:12px"
                    class="time2"
                    :clearable="false">
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" @click="clearTime()"></i>
                <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
              </div>
            </div>

            <div class="input-box">
              <!-- <span class="input-title">手机号码</span> -->
              <el-input
                class="input"
                style="width: 240px"
                size="small"
                placeholder="请输入买家账号/手机号码/备注"
                v-model="searchParams.mobile"
              ></el-input>
            </div>
            <div class="input-box">
              <el-button
                icon="el-icon-search"
                class="search_btn"
                size="small"
                :style="{'color':globalBG,'border-color':globalBG}"
                @click="search"
                :disabled="tableLoading"
              >查询</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="table_module">
        <!-- 按钮部分 -->
        <div class="button-box">
          <div class="float-left-button">
            <div
              class="button"
              @click="showBlackDialog"
              :style="{'background':globalBG,'border-color':globalBG}"
            >
              <span class="button-title" style="color: #fff;">
                <i class="el-icon-circle-plus" style="margin-right: 2px;"></i>添加黑名单
              </span>
            </div>
            <div
              class="button"
              @click="bothDelete()"
              :style="{'color':globalBG,'border-color':globalBG}"
            >
              <span class="button-title">删除黑名单</span>
            </div>
            <div
              class="button"
              @click="searchResultDetele"
              :style="{'color':globalBG,'border-color':globalBG}"
            >
              <span class="button-title">按查询结果删除</span>
            </div>
          </div>
          <div class="float-right-button">
            <!-- <div class="button" @click="dialogVisible =true,handlClear()"> -->
            <!-- <img src="@/assets/images/daoru.png" class="button_icon" style="padding-bottom: 2px;"> -->
            <!-- <span class="button-title"></span>导入数据</span>
            </div>-->
            <el-button @click="dialogVisible =true,handlClear()" class="width_96">导入数据</el-button>
            <el-button @click="exportInfo" class="width_96">导出数据</el-button>
            <!-- <div class="button" @click="exportInfo">
              <img src="@/assets/images/daochu.png" alt="" class="button_icon">
              <span class="button-title">导出</span>
            </div>-->
          </div>
          <div style="clear: both;"></div>
        </div>
        <!-- 表格部分 -->
        <div class="table-box">
          <el-table
            ref="multipleTable"
            tooltip-effect="light"
            :data="tableData"
            :header-cell-style="{background:'#FAFAFA'}"
            style="width: 100%; border: 1px solid #eee;"
            @selection-change="handleSelectionChange"
            stripe
            v-loading="tableLoading"
          >
            <template slot="empty">
              <div>
                <img src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column type="selection" width="40"></el-table-column>
            <!-- <el-table-column label="客户编号" prop="buyerNick"></el-table-column>
            <el-table-column label="客户昵称" prop="buyerNick"></el-table-column>-->
            <el-table-column label="手机号码" prop="mobile"></el-table-column>
            <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="createTime" label="添加时间"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="handleDelete(scope.$index, scope.row.smsBlacklistId)"
                  :style="{'color':'#f56c6c'}"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div class="block">
            <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchParams.pageNum"
              :page-sizes="[10, 20, 30, 50,100,500]"
              :page-size="searchParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 添加黑名单弹窗 -->
    <el-dialog
      title="添加黑名单"
      :visible.sync="addBlackList"
      width="570px"
      style
      class="addBlack_Dialog"
    >
      <div class="add-black-list-dialog">
        <div class="remark-box">
          <!-- <el-radio v-model="radio" label="2" @change="buyersWant">买家旺旺</el-radio> -->
          <!-- <el-radio v-model="radio" label="1" @change="buyersWant">手机号码</el-radio> -->
          输入客户pin:
        </div>
        <el-input
          type="textarea"
          :rows="4"
          v-if="placeholder='请输入买家账号/手机号码'"
          v-model="remarkTextarea"
        ></el-input>
        <div class="warn-tips">
          <!-- <img src="../../assets/images/tishi.png" > -->
          <i class="el-icon-warning warn-icon"></i>
          <span class="warn-content">多个账号/号码用","隔开</span>
        </div>
        <span class="tips">备注:</span>
        <div class="remark-box">
          <el-input
            type="textarea"
            :rows="4"
            placeholder="输入备注内容"
            v-model="commentTextarea"
            maxlength="50"
            @change="changeData"
          ></el-input>
          <div class="remark-tips">{{commentTextarea.length}}/50</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addBlackList = false" class="width_96">取消</el-button>
        <el-button type="primary" @click="addData" class="width_96">确认</el-button>
      </div>
    </el-dialog>
    <!-- 导入手机弹框部分:before-close="handleClose"-->
    <el-dialog title="导入黑名单" :visible.sync="dialogVisible" width="570px">
      <!-- 开头标签 -->
      <el-form ref="form" label-width="80px">
        <!-- <el-form-item label="导入类型:">
          <template>
        <el-radio v-model="mobileType" label="0">手机号码</el-radio>-->
        <!-- <el-radio v-model="mobileType" label="1">客户昵称</el-radio>
        <el-radio v-model="mobileType" label="2">客户编号</el-radio>-->
        <!-- </template>
        </el-form-item>-->
        <div>
          <el-upload
            :action="uploadUrl"
            class="upload-demo"
            ref="upload"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeUpload"
            :on-success="upLoadSuccess"
            :on-error="uploadError"
            :data="{mobileType:mobileType}"
            :file-list="fileList"
          >
            <el-button
              style="margin-right:10px;background: #fff;"
              slot="trigger"
              size="small"
              class="width_106"
            >
              <img src="@/assets/images/daochu.png" alt class="button_icon" />上传文件
            </el-button>
            <el-button
              size="small"
              type="text"
              @click="downloadTemplate"
              style="color: #7F85E9"
            >下载模板</el-button>
            <div
              style="display:inline-block;width:250px;height:33px;margin-left:5px;"
              v-if="isupload"
              class="procontain"
            >
              <div class="proInfo" :style="{'color':stateColor}">
                {{loadState}}
                <i
                  v-if="success===false"
                  @click="reload($event)"
                  class="el-icon-refresh"
                  style="display:inline-block;margin:0 3px;color:#999;height:20px;line-height:20px;vertical-align:top;"
                ></i>
                <div class="proclose" @click="closePro($event)">
                  <i style="color:#999" class="el-icon-close"></i>
                </div>
              </div>
              <el-progress :percentage="process" v-if="success===''"></el-progress>
              <!--正常进度-->
              <el-progress
                :percentage="process"
                status="success"
                v-if="process===100 && success===true"
              ></el-progress>
              <!--进度成功-->
              <el-progress
                :percentage="process"
                status="exception"
                v-if="process===100 && success===false"
              ></el-progress>
              <!--进度失败-->
            </div>
          </el-upload>
        </div>
        <div class="warn-tips">
          <i class="el-icon-warning warn-icon"></i>
          <span class="warn-content">文件不能超过50M，重复号码自动过滤！（只支持xlsx、xls两种类型的上传文件）</span>
        </div>
        <div class="rem">
          <!-- <el-form-item label="备注:">
            <el-input type="textarea" v-model="remark" maxlength="50" rows="4" class="em-input"></el-input>
            <span class="quantLimit">{{remark.length}}/50</span>
          </el-form-item>-->
          <div style="margin-bottom:8px">备注:</div>
          <el-input
            type="textarea"
            v-model="remark"
            maxlength="50"
            rows="4"
            class="em-input"
            placeholder="请输入备注内容"
          ></el-input>
          <span class="quantLimit">{{remark.length}}/50</span>
        </div>
        <!-- <span class="textPrompt">注:1.仅支持xls/xlsx格式文件,文件大小不超过50M；
        <span style="display: block;margin-left: 77px;">2.自动过滤重复号码；</span></span>-->
        <el-form-item style="text-align: right;margin: 20px 0 0 0;">
          <el-button @click="dialogVisible = false" class="width_96">取消</el-button>
          <el-button type="primary" @click="submitUpload()" class="width_96">上传文件</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 导出数据弹窗部分 -->
    <el-dialog title="导出数据" :visible.sync="exportDer" width="670px" style="min-width: 1200px;">
      <template>
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
        <div style="margin: 15px 0;"></div>
        <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
          <el-checkbox v-for="city in cities" :label="city" :key="city">{{city}}</el-checkbox>
        </el-checkbox-group>
      </template>
      <div slot="footer" class="dialog-footer">
        <el-button @click="exportDer = false" class="width_96">取消</el-button>
        <el-button type="primary" @click="exportData" class="width_96">导出</el-button>
      </div>
    </el-dialog>

    <!-- 导入成功后的提示 -->
    <el-dialog title="温馨提示" :visible.sync="importTipDialog" width="300px" style="margin-top:18vh">
      <div>总上传记录为{{importTotalNum}}条,成功记录数{{successNum}}条</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importTipDialog = false">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog title="提示" :visible.sync="sureDialogVisible" width="400px" style="margin-top: 25vh;">
      <div class="sure_text">
        <img src="../../assets/images/i_icon.png" class="i_icon" />
        <span>确定要删除吗？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sureDialogVisible = false" class="width_96">取 消</el-button>
        <el-button type="primary" @click="sureDialogVisible = false" class="width_96">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import {
//   addBlackList,
//   deleteBlackList,
//   deleteBlackListByCondition,
//   exportBlackList,
//   getBlackList,
//   importBlackList,
//   blackUploadMobileFile,
//   // uploadMobileFile
// } from "@/api/backList";
import { mapState } from "vuex";
import topTitle from "@/components/top-title.vue";
const cityOptions = ["手机号码", "备注", "添加时间"];
const cityOption = true;
// const city
export default {
  name: "black_list",
  components: {
    topTitle
  },
  data() {
    return {
      name: "黑名单",
      timeRangePicker: ["", ""],
      startTime: '',
      endTime: '',
      tableLoading: false,
      sureDialogVisible: false, // 确认删除弹窗
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     if (this.searchParam2.startTime) {
      //       return (
      //         time.getTime() <
      //         new Date(this.searchParam2.startTime).getTime()
      //       );
      //     } else {
      //     }
      //   }
      // },
      // pickerOptionsStart: {
      //   disabledDate: time => {
      //     if (this.searchParam2.endTime) {
      //       return (
      //         time.getTime() >
      //         new Date(this.searchParam2.endTime).getTime()
      //       );
      //     } else {
      //     }
      //   }
      // },
      fileId: "",
      mobileType: "0",
      remark: "",
      uploadUrl: "",
      fileName: "",
      fileList: [],
      cellPhon: "",
      wangWang: "",
      process: 0,
      success: "",
      stateColor: "#409eff",
      proTimer: null,
      isupload: false,
      uid: "", //导入的文件id
      wordLength: 0, //获取备注字数长度
      commentTextarea: "", //加入黑名单文本数据框
      addChecked: 1, //加入黑名单选择类型数据按钮
      exportDialog: false, //导出数据
      totalCount: [], //数据总条数
      addBlackList: false, //添加黑名单按钮
      exportDer: false, //导出数据
      phoneTextarea: [], //手机号码输入框
      remarkTextarea: "", //备注输入框
      joinRemarkTextarea: "", //加入黑名单备注内容
      multipleSelection: [], //表格多选数据
      taskTime: [], //时间绑定
      tableData: [], //请求黑名单列表的数据
      dialogVisible: false,
      radio: "1", //绑定弹框
      /* 
      导出数据弹窗
      */
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: false,
      educe: {
        buyerNick: "",
        endCreateTime: "",
        exportCell: ["手机号码", "备注", "添加时间"],
        mobile: "",
        remark: "",
        buyerNick: "",
        startCreateTime: ""
      },
      /* 
      导入数据弹窗
      */
      checked: false,
      checke: false,
      /* 
      表格数据
      */
      searchParams: {
        // buyerNick: "",
        endCreateTime: "",
        pageNum: 1,
        pageSize: 10,
        mobile: "",
        remark: "",
        buyerNick: "",
        startCreateTime: ""
      },
      // form表单
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      //taskTimeChange:"",
      importTipDialog: false, //导入成功后显示的提示信息框
      successNum: "",
      importTotalNum: "",
      searchParam2: {
        startTime: "",
        endTime: ""
      }
    };
  },

  //监听日期时间改变
  computed: {
    loadState() {
      //进度条状态
      if (this.success === "") {
        this.stateColor = "#409eff";
        return `上传中(%${this.process})`;
      }
      if (this.process === 100 && this.success === true) {
        this.stateColor = "#49C568";
        return `上传成功`;
      }
      if (this.process === 100 && this.success === false) {
        this.stateColor = "#F56C6C";
        return `上传失败`;
      }
    },
    taskTimeChange: {
      get: function() {
        return this.taskTime;
      },
      set: function(value) {
        // console.log(value)
        this.taskTime = value;
        // console.log(value);
        this.searchParams.startCreateTime = value[0];
        this.searchParams.endCreateTime = value[1];
      }
    },
    ...mapState({
      globalBG: "globalBG"
      //   把city映射给currentCIty
    })
  },
  watch: {
    taskTimeChange(value) {
      value[1] = new Date(this.ToStrfommatShort(value[1]) + " 23:59:59");
    }
  },
  methods: {
    clearTime() {
      
    },
    showBlackDialog() {
      // console.log("111");
      this.addBlackList = true;
    },
    closePro(ev) {
      this.isupload = false;
      ev.cancelBubble = true; //阻止冒泡
    },
    reload(ev) {
      // console.log(this.$refs);
      this.$refs.upload.$children[0].$el.click();
      ev.cancelBubble = true; //阻止冒泡
    },
    /* 
    按按查询结果删除按钮事件
    */
    searchResultDetele() {
      if (this.tableData.length == 0) {
        this.$message.error("没有符合条件的号码");
        return;
      }
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteBlackListByCondition(this.searchParams).then(res => {
            // console.log(res);
            this.backTolist();
          });
          this.$message.success("删除成功!");
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    /* 
     添加黑名单获取备注内容字数
    */
    changeData(val) {
      this.wordLength = val.length;
    },
    /* 
     添加黑名单绑定按钮事件
    */
    buyersWant(val) {
      this.remarkTextarea = "";
      this.commentTextarea = "";
      this.addChecked = val;
    },
    exportInfo() {
      if (!this.tableData.length) {
        this.$message.warning("没有可以导出的数据");
        return;
      }
      this.exportDer = true;
    },
    /* 
    导出数据
    */
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      // console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    /* 
     黑名单列表请求函数
    */
    backTolist() {
      // let time1 = this.searchParam2.startTime;
      let time1 = this.timeRangePicker[0];
      // let time2 = this.searchParam2.endTime;
      let time2 = this.timeRangePicker[1];
      this.searchParams.startCreateTime = "";
      this.searchParams.endCreateTime = "";
      if (time1) {
        if (time1.length == 0 || typeof time1 == "null") {
        } else {
          this.searchParams.startCreateTime = time1;
        }
      }
      if (time2) {
        if (time2.length == 0 || typeof time2 == "null") {
        } else {
          this.searchParams.endCreateTime = time2;
        }
      }

      this.tableLoading = true;
      getBlackList(this.searchParams)
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data.records;
            this.totalCount = { total: res.data.total };
          }
          this.tableLoading = false;
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    /*
     * 监听表格多选事件
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /* 
     搜索
    */
    search() {
      console.log("timeRangePicker", this.timeRangePicker);
      this.searchParams.pageNum = 1;
      this.backTolist();
    },
    /*
     * 删除黑名单事件
     * */
    handleDelete(index, row) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass:"iconfont iconicon-jinggao1",
      })
        .then(() => {
          deleteBlackList({ smsBlacklistIds: row }).then(res => {
            this.backTolist();
          });
          this.$message.success("删除成功!");
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },
    /*
     * 批量删除黑名单事件
     * */
    bothDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("确定要删除吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          iconClass:"iconfont iconicon-jinggao1",
        })
          .then(() => {
            //取值
            const valueId = this.multipleSelection.map(item => {
              return item.smsBlacklistId;
            });
            let stringId = valueId.join(",");
            deleteBlackList({ smsBlacklistIds: stringId }).then(res => {
              this.backTolist();
            });
            this.$message.success("删除成功!");
          })
          .catch(() => {
            this.$message.info("已取消删除");
          });
      } else {
        this.$message.warning("请勾选删除项");
      }
    },
    /* 
      分页事件
    */
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.backTolist();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.backTolist();
    },
    /* 
     添加黑名单事件
    */
    addData() {
      console.log(this.remarkTextarea);
      // console.log(this.commentTextarea);
      //多情况,换行可以
      if (this.remarkTextarea.indexOf("\n") !== -1) {
        let stry = this.remarkTextarea.split("\n");
        this.remarkTextarea = stry.join(",");
      }
      addBlackList({
        estimate: this.addChecked,
        account: this.remarkTextarea,
        remark: this.commentTextarea
      }).then(res => {
        this.backTolist();
        this.addBlackList = false;
        this.$message.success(res.message);
        this.remarkTextarea = "";
        this.commentTextarea = "";
      });
    },
    /* 
    导出数据事件
    */
    exportData() {
      let that = this;
      if (!this.checkedCities.length) {
        this.$message.warning("请选择要导出的数据");
        return;
      }

      this.educe.exportCell = this.checkedCities;

      exportBlackList(this.educe)
        .then(res => {
          if (res.code === 200) {
            let url = res.data;
            let start = url.lastIndexOf(".");
            // console.log(start);
            let type = url.substring(start);
            // console.log(type);
            let fileName = res.data;
            // let fileNameArr = fileName.split("/");
            // let newFileName = fileNameArr[fileNameArr.length-1];
            let elem = document.createElement("a");
            elem.style.display = "none";
            elem.href = that.$BaseUrl + "/file_xls/" + url;
            elem.setAttribute("download", fileName);
            document.body.appendChild(elem);
            elem.click();
          }
          this.exportDer = false;
        })
        .catch(err => {
          this.exportDer = false;
        });
    },
    handlClear() {
      // console.log('2342342')
      this.mobileType = "0";
      this.isupload = false;
      this.process = 0;
      this.proTimer = null;
      this.success = "";
      this.fileList = [];
      this.remark = "";
    },
    downloadTemplate() {
      let url = "",
        fileName = "";
      if (this.mobileType === "0") {
        url = "/api/templateDir/黑名单导入手机号模板.xlsx";
        fileName = "黑名单导入手机号模板.xlsx";
      }
      if (this.mobileType === "1") {
        url = "/api/templateDir/黑名单导入旺旺号模板.xlsx";
        fileName = "黑名单导入旺旺号模板.xlsx";
      }
      // let start = url.lastIndexOf(".");
      // let type = url.substring(start);
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    /* 
    点击上传功能,上传之前的大小校验
    */
    beforeUpload(file) {
      let that = this;
      this.isupload = false;
      this.$nextTick(() => {
        that.process = 0;
        that.success = "";
        that.isupload = true;
        that.proTimer = setInterval(() => {
          if (that.process < 100) {
            that.process++;
          } else {
            clearInterval(that.proTimer);
          }
        }, 20);
      });
      // 这里是获取文件的id号
      this.uid = file.uid;
      this.files = file;
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        this.process = 100;
        this.success = false;
        //this.fileList = [];
        return;
      }
      if (!isLt2M) {
        this.process = 100;
        this.success = false;
        this.$message.warning("上传模板大小不能超过 50MB!");
        return;
      }
      this.fileName = file.name;
      // return false; // 返回false不会自动上传
    },
    /**
     * 上传文件成功
     */
    upLoadSuccess(file, fileList) {
      // console.log(this.fileList);
      console.log("upLoadSuccess==", file, fileList);
      if (file.code == "200") {
        this.process = 100;
        this.success = true;
        this.fileId = file.data;
        this.$message.success("上传成功!!!");
        // this.fileList = []
      } else {
        this.process = 100;
        this.success = false;
        this.$message.error(file.message);
        this.fileList = [];
      }
      // console.log(fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择1个文件`);
    },
    uploadError(file, fileList) {
      this.process = 100;
      this.success = false;
      this.fileList = [];
      // console.log(file)
      // console.log(fileList)
    },
    /* 
    手动上传确认提交
    */
    submitUpload() {
      // console.log("上传" + this.fileId);
      if (this.fileId == "") {
        this.$message.error("请选择要上传的文件！");
        return false;
      }
      importBlackList({
        fileId: this.fileId,
        mobileType: this.mobileType,
        remark: this.remark
      })
        .then(res => {
          // console.log(res);
          // this.$message.success('提交成功!');
          this.fileId = "";
          this.backTolist();
          this.dialogVisible = false;
          this.fileList = [];
          this.importTotalNum = res.data.uploadTotal;
          this.successNum = res.data.validCount;
          this.importTipDialog = true;
        })
        .catch(() => {
          // console.log(err)
        });
    }
  },
  // 刷新黑名单列表
  mounted() {
    // this.backTolist();
    this.uploadUrl = blackUploadMobileFile();
  },
  created() {
    // this.backTolist();
  }
};
</script>
<style lang="scss" scoped>
.warn-tips {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  // padding: 0px 15px;
  margin-top: 10px;
  margin-bottom: 20px;
  height: 24px;
  // background:rgba(255,185,94,0.1);
  // border:1px solid rgba(255,185,94,1);
  border-radius: 2px;
  line-height: 19px;
  color: #999;
  font-size: 14px;
  .warn-icon {
    display: inline-block;
    vertical-align: middle;
    margin-right: 8px;
    font-size: 14px;
    color: #fe8f8a;
  }
  .warn-content {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
  }
}
.procontain {
  text-align: left;
  .proInfo {
    height: 20px;
    line-height: 20px;
    padding-right: 50px;
    overflow: hidden;
    .proclose {
      float: right;
      height: 20px;
      line-height: 20px;
    }
  }
}
.section-right-content-box {
  color: #666;
  // background-color: #fff;
  /*box-shadow: 0 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  // padding: 22px 30px 26px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 20px;
  .tips-title {
    height: 32px;
    line-height: 26px;
    background: rgba(248, 250, 255, 1);
    padding-left: 15px;
    margin-bottom: 20px;
    text-align: left;
    border: 1px solid rgba(172, 193, 254, 1);
    .notice-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8.49px;
    }
    .notice-content {
      display: inline-block;
      vertical-align: middle;
      .black-type {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        // font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .screen-box {
    text-align: left;
    .item {
      .input-box {
        display: inline-block;
        vertical-align: middle;
        margin-right: 16px;
        // margin-bottom: 10px;
        .input-title {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          color: #333333;
          width: 76px;
        }
        .input {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
        }
      }
    }
  }
  .button-box {
    margin-bottom: 10px;
    .float-left-button {
      float: left;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        border: 1px solid #2062e7;
        color: #2062e7;
        font-size: 14px;
        min-width: 96px;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        margin-right: 10px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          height: 30px;
          line-height: 30px;
          vertical-align: middle;
          font-size: 14px;
        }
      }

      .button:last-child {
        margin-right: 0;
      }
    }
    .float-right-button {
      float: right;
      .el-button--small {
        font-size: 14px;
      }
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        // vertical-align: middle;
        padding: 5px 12px;
        // border: 1px solid #2062e7;
        // color: #2062e7;
        font-size: 14px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          vertical-align: middle;
        }
      }

      .button:last-child {
        margin-right: 0;
      }
    }
  }
}
/* 添加黑名单 模态框 */
.add-black-list-dialog {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  // width: 368px;
  text-align: left;
  margin: 0 auto;
  .tips {
    display: block;
    font-size: 14px;
    margin-bottom: 6px;
    color: #666;
  }

  .remark-box {
    position: relative;
    margin-bottom: 7px;
    color: #333;
    .remark-tips {
      position: absolute;
      right: 5px;
      bottom: 5px;
      color: #999;
    }
  }
}

/* 加入黑名单 模态框 */
.join-black-list-dialog {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
  .phoneType {
    margin-bottom: 10px;
  }
  .item {
    margin-bottom: 12px;
    .item-name {
      display: inline-block;
      vertical-align: middle;
      width: 70px;
      text-align: right;
    }
    .highlight-text {
      display: inline-block;
      vertical-align: middle;
      font-size: 24px;
      font-weight: 300;
      color: rgba(255, 118, 0, 1);
      margin-right: 3px;
    }
    .remark-box {
      display: inline-block;
      vertical-align: text-top;
      width: 368px;
      position: relative;
      .remark-tips {
        position: absolute;
        bottom: 5px;
        right: 5px;
        color: #999;
      }
    }
  }
}
//导入手机弹框样式
.textPrompt {
  color: #fd695b;
  margin-left: 60px;
  font-size: 14px;
}
.upFile {
  margin-left: 50px;
  margin-top: 30px;
}
.templateDown {
  border: 1px solid #ccc;
  height: 130px;
  width: 278px;
  .shangFile {
    margin-left: 5px;
    margin-top: 20px;
    padding: 5px 15px;
  }
  .download {
    margin-left: 15px;
    color: blue;
  }
}
.rem {
  position: relative;
  overflow: hidden;
  .em-input {
    // padding-right: 30px
  }
  .quantLimit {
    position: absolute;
    clear: both;
    // left: 390px;
    right: 15px;
    bottom: 5px;
    font-size: 14px;
  }
}

// 时间选择器
.picker {
  display: inline-block;
  vertical-align: middle;
  width: 200px;
}
.dialog-footer {
  text-align: center !important;
}

.search_module {
  padding: 24px 28px;
  background: #fff;
  border-radius: 6px;
  // height: 234px;
  // border: 1px solid rgba(230,230,230,1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  margin-bottom: 20px;
}
.search_btn {
  width: 98px;
  height: 32px;
  // background:#5882FB;
  opacity: 1;
  border-radius: 3px;
  // margin-bottom: 30px;
  // margin-top: 6px;
  font-size: 14px;
  padding: 0px;
}
.table_module {
  padding: 30px 30px 26px;
  background: #fff;
  // border: 1px solid rgba(230,230,230,1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  border-radius: 6px;
}
.button_icon {
  width: 12px;
  vertical-align: text-top;
  margin-right: 3px;
}
.width_96 {
  width: 98px;
}
.width_106 {
  width: 106px;
}
.sure_text {
  font-size: 14px;
  // font-family: PingFang SC;
  font-weight: 500;
  line-height: 21px;
  color: rgba(51, 51, 51, 1);
}
.i_icon {
  height: 36px;
  vertical-align: middle;
  margin-right: 20px;
}

// @media screen and(max-width: 1740px) {
//   .screen-box .input-box {
//     margin-right: 100px!important;
//   }
// }
// @media screen and(max-width: 1717px) {
//   .screen-box .input-box {
//     margin-right: 50px!important;
//   }
// }
// @media screen and(max-width: 1570px) {
//   .screen-box .input-box {
//     margin-right: 20px!important;
//   }
// }
</style>
<style lang="scss">
.black_list {
  // 弹窗样式修改
  // .addBlack_Dialog{
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    padding: 24px 30px 30px;
    font-size: 14px;
  }
  .el-dialog__footer {
    padding: 0px 30px 24px;
    .dialog-footer {
      margin-top: 0px;
      text-align: right !important;
    }
  }

  .el-table .cell {
    padding: 0 10px !important;
  }
}
</style>
